module.exports = __webpack_public_path__ + "img/bb.2a58b1c5.png";